import React, { useRef } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
const CULobbyWise = ({ data, monthLength }) => {
  const tableRef = useRef();
  return (
    <div className=" newUiBody">
      <h5 className="text-white bg-black p-1 mb-1"> Lobby wise Utilization</h5>
      <div
        className="table-responsive  m-0 p-0"
        style={{ height: "400px", overflow: "auto" }}
      >
        <table
          className="table newUiTable table-hover table-striped flex-grow-1 mt-0 pt-0"
          ref={tableRef}
        >
          <thead
            className="table-dark sticky-top pt-0 mt-0"
            style={{ zIndex: 2 }}
          >
            <tr>
              <th>Sno.</th>
              <th>Lobby</th>
              <th> Util %</th>
              <th> Util (Freight)%</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((obj, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{obj.ut_lobby}</td>
                    <td>
                      {(Number(obj.ut_percentage_util) / monthLength).toFixed(
                        0
                      )}
                    </td>
                    <td>
                      {(
                        Number(obj.ut_percentage_util_fght) / monthLength
                      ).toFixed(0)}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`month wise utilization`} />
    </div>
  );
};
export default CULobbyWise;
